import React, { useEffect } from "react";
import { useState } from "react";
import { Card, Col, Form, Row, Spinner } from "react-bootstrap";

import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import {
      FormButton,
      FormDescription,
      FormInput,
      FormStatusSelect,
} from "../../components/form";
import { privateApi } from "../../api";

const AssociationCategoryEdit = () => {
      const { categoryId } = useParams();
      const [loadingData, setLoadingData] = useState(false);

      const [title, setTitle] = useState("");
      const [status, setStatus] = useState("");
      const [description, setDescription] = useState("");
      const [loading, setLoading] = useState(false);

      const loadData = async () => {
            setLoadingData(true);
            await privateApi
                  .get(`/dashboard/association_categories/${categoryId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setTitle(response.data.category.title);
                              setStatus(response.data.category.status);
                              setDescription(
                                    response.data.category.description
                              );
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  status: status,
                  description: description,
            };

            await privateApi
                  .post(`/dashboard/association_categories/${categoryId}`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                              if (response.data.message.description) {
                                    toast.error(
                                          response.data.message.description
                                    );
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Edit Category">
                                                <LinkButton
                                                      title="Back"
                                                      link="/dashboard/association_categories"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                {!loadingData ? (
                                                      <Row className="g-3">
                                                            <FormInput
                                                                  title="Title"
                                                                  classes={8}
                                                                  required={
                                                                        true
                                                                  }
                                                                  value={title}
                                                                  handleChange={
                                                                        setTitle
                                                                  }
                                                            />
                                                            <FormStatusSelect
                                                                  title="Status"
                                                                  classes={4}
                                                                  selected={
                                                                        status
                                                                  }
                                                                  setStatus={
                                                                        setStatus
                                                                  }
                                                            />
                                                            <FormDescription
                                                                  title="Description"
                                                                  setDescription={
                                                                        setDescription
                                                                  }
                                                                  height="200px"
                                                                  description={
                                                                        description
                                                                  }
                                                            />
                                                      </Row>
                                                ) : (
                                                      <div className="h-25 text-center">
                                                            <Spinner />
                                                      </div>
                                                )}
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default AssociationCategoryEdit;
